/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Creditpack_Description1Inputs */

const zh_creditpack_description1 = /** @type {(inputs: Creditpack_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一次性充值积分，永不过期。`)
};

const en_creditpack_description1 = /** @type {(inputs: Creditpack_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One-time credit top-ups. Credits never expire.`)
};

const es_creditpack_description1 = /** @type {(inputs: Creditpack_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recargas de créditos únicas. Los créditos nunca expiran.`)
};

/**
* | output |
* | --- |
* | "One-time credit top-ups. Credits never expire." |
*
* @param {Creditpack_Description1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const creditpack_description1 = /** @type {((inputs?: Creditpack_Description1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Creditpack_Description1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_creditpack_description1(inputs)
	if (locale === "en") return en_creditpack_description1(inputs)
	return es_creditpack_description1(inputs)
});
export { creditpack_description1 as "creditPack_description" }